import {BsCaretDownFill, BsCaretUpFill} from "react-icons/bs";
import {ProjectColors} from "../../../Enums/Core/projectColors";
import React from "react";

export default function Arrow(props) {
    return (
        <>
            { props.isPositive && <BsCaretUpFill style={{fontSize: 'xxx-large', color: props.isColored ? ProjectColors.Red : ProjectColors.Gray}} /> }
            { !props.isPositive && <BsCaretDownFill style={{fontSize: 'xxx-large', color: props.isColored ? ProjectColors.Green : ProjectColors.Gray}} /> }
        </>
    )
}
